import moment from 'moment';

export interface IAcceptFilterData {
  field: any;
  filter: string;
  selectedValues: any[];
  isAllSelected: boolean;
  connectionFilterValues?: any[];
};

export enum FilterComparision {
  EQUAL,
  LIKE_LEFT,
  LIKE_FULL
};

export const makeFilter = (field: any, value: any, compare: FilterComparision) => {

  if (field.type === 'date') {
    return `to_char("${field.name}" + interval '${moment().utcOffset()} minutes','DD.MM.YYYY') LIKE '${compare=== FilterComparision.EQUAL ? moment(value).format('DD.MM.YYYY') : value}%'`;
  }
  if (field.type === 'timeminutes') {
    if (compare === FilterComparision.EQUAL) {
      return `"${field.name}"=${value}`;
    } else
      return `concat(TO_CHAR(FLOOR("${field.name}"/60),'FM00'),':',TO_CHAR(FLOOR("${field.name}"%60),'FM00')) ILIKE '${compare === FilterComparision.LIKE_FULL ? '%' : ''}${value}${compare === FilterComparision.LIKE_FULL || compare === FilterComparision.LIKE_LEFT ? '%' : ''}'`;
  }
  if (field.type === 'connetioncombobox' && Array.isArray(value)) {
    return `"${field.name}" @> '{${value.join(',')}}' AND "${field.name}" <@ '{${value.join(',')}}'`;
  }
  if (value === null) {
    return `"${field.name}" is null`;
  }
  return `"${field.name}"::TEXT ILIKE '${compare === FilterComparision.LIKE_FULL ? '%' : ''}${value}${compare === FilterComparision.LIKE_FULL || compare === FilterComparision.LIKE_LEFT ? '%' : ''}'`;
};

export const makeAllFilter = (allFilters: { [key: string]: IAcceptFilterData }): string => {
    if (allFilters) {
      return Object.keys(allFilters).map((k: string): string => {
        const filter = allFilters[k];
        // console.log(filter.connectionFilterValues, filter.selectedValues)
        if (filter && (filter.filter != '' || (filter.selectedValues || []).length > 0)){
          const res = (filter.isAllSelected && !filter.connectionFilterValues) ?
            makeFilter(filter.field, filter.filter, FilterComparision.LIKE_FULL)
            :
            ((filter.isAllSelected && filter.connectionFilterValues) || filter.selectedValues || []).map((vl: string) => {
              return makeFilter(filter.field, vl, FilterComparision.EQUAL)
            }).filter((el: string) => el.trim() !== '').join(' OR ');
          return `(${res})`;
        }
        return '';
      }).filter((el: string) => el.trim()!=='').join(' AND ');
    }
    return '';
}

export const convertMinutesToTime = (minutes: number | null) => {
  if (minutes === null) {
    return '';
  }
  if (!minutes) {
    return '00:00';
  }
  const hr = Math.floor(minutes / 60);
  const min = minutes % 60;
  return `${hr < 10 ? '0' : ''}${hr}:${min<10?'0':''}${min}`;
}

export const convertTextToMinutes = (txt?: string): number | null => {
  if (!txt || txt==='') {
    return null;
  }
  const [hr, min] = txt.split(':');
  const res = (hr.replace(/_/g, '0').length > 0 ? parseInt(hr.replace(/_/g, '0')) : 0) * 60 + (min.replace(/_/g, '0').length > 0 ? parseInt(min.replace(/_/g, '0')) : 0);
  if (isNaN(res)) {
    return null;
  }
  return res;
}